module.exports = __webpack_public_path__ + "static/media/pg_sample_rings.b26683be.svg";